<template>
  <div class="container">
    <div class="preloader" v-if="preloader">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <form class="user-plan">
      <p class="user-plan__title">Цели презентации</p>

      <div
        class="input-group"
        v-for="field in collectionInfo.goal"
        :key="field.id"
      >
        <input
          type="text"
          v-model="field.name"
          class="input-group__target"
          :placeholder="'Цель' + field.id"
        />
        <input
          type="text"
          v-model="field.plan"
          class="input-group__plan"
          :placeholder="'План' + field.id"
        />
      </div>
      <div class="addInput" @click="addTargetField">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon icon-tabler icon-tabler-square-plus"
          width="44"
          height="44"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="rgba(196, 196, 196, 0.3)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" />
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <line x1="9" y1="12" x2="15" y2="12" />
          <line x1="12" y1="9" x2="12" y2="15" />
        </svg>
      </div>
      <p class="submitForm" :class="{blockedButton: blockButton}" @click="sendForm">{{buttonText}}</p>
    </form>
  </div>
</template>

<script>
export default {
  data: () => ({
    collectionInfo: {
      presentationID: "",
      goal: [
        {
          id: 1,
          name: "",
          plan: "",
        },
      ],
    },
    buttonText: 'Запланировать презентацию',
    popupText: 'Презентация успешно запланирована!',
    blockButton: false,
    preloader: false
  }),
  methods: {
    addTargetField() {
      let len = Object.keys(this.collectionInfo.goal).length + 1;
      this.collectionInfo.goal.push({
        id: len,
        name: "",
        plan: "",
      });
    },
    sendForm() {
        this.blockButton = true;
        this.preloader = true;
        if(this.collectionInfo){
            this.$store
                .dispatch("UPDATE_PRESENTATION", this.collectionInfo)
                .then((response) => {
                if (response.status == 200) {

                    this.$makeToast(
                    "Отлично!",
                    "success",
                    `${this.popupText}`,
                    3000
                    );
                    this.$localStorageDelete('RegistrationCollectionInfo');
                    this.$localStorageDelete('editPresentationInfo');

                    setTimeout(() => {
                    this.$router.push("/mainPage");
                    }, 3000);
                }
                });
        }
    },
  },
  created() {
    this.collectionInfo.presentationID = this.$route.params.collectionID;
    let editPresentInfo = this.$localStorageGet('editPresentationInfo');
    if(editPresentInfo){
      this.buttonText = "Сохранить"
      this.popupText = "Презентация успешно сохранена"
      this.collectionInfo.goal = editPresentInfo.goal;
    }
  },
};
</script>

<style lang="scss" scoped>
.user-plan {
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.user-plan__title {
  font-size: 18px;
  text-transform: uppercase;
  color: #ffffff;
  padding-bottom: 60px;
}
.input-group {
  width: 250px;
  margin-bottom: 15px;

  input {
    width: 100%;
    height: 20px;
    font-size: 12px;
    background: none;
    border: none;
    outline: none;
    color: rgba(255, 255, 255, 0.5);

    &:hover,
    &:focus {
      border: none;
      outline: none;
      box-shadow: none;
      background: none;
    }
    &.input-group__target {
      border-bottom: 1px solid #fff;
    }
    &.input-group__plan {
      background: rgba(196, 196, 196, 0.3);
    }
  }
}
.addInput {
  margin-top: 20px;
  margin-bottom: auto;
}
.submitForm {
  font-size: 18px;
  text-transform: uppercase;
  color: #000000;
  display: flex;
  align-items: center;
  background: #fff;
  width: 100%;
  justify-content: center;
  height: 50px;
  position: fixed;
  bottom: 0;
}
</style>